import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type MutationInput = {
  reportId: string;
  clientId?: string;
  familyId?: string;
};

export function useDeleteSuitabilityReport() {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<unknown, Error, MutationInput>({
    mutationFn: ({ clientId, familyId, reportId }: MutationInput) =>
      api.delete(
        familyId
          ? `families/${familyId}/suitability-reports/${reportId}`
          : `clients/${clientId}/suitability-reports/${reportId}`,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['clients'] });
    },
  });

  const deleteSuitabilityReport = async (clientId: string, reportId: string) => {
    return mutateAsync({ clientId, reportId });
  };

  const deleteFamilySuitabilityReport = async (familyId: string, reportId: string) => {
    return mutateAsync({ familyId, reportId });
  };

  return {
    deleteSuitabilityReport,
    deleteFamilySuitabilityReport,
    error,
    isLoading,
    reset,
  };
}
